import { useSelector } from 'react-redux';
import React, { useState, useEffect } from 'react';

import './clarenceWidget.css';
import ClarenceChat from './ClarenceChat';
import { SHOW_AI_FEATURES } from '../../env';

const ClarenceWidget = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);
    const user = useSelector(state => state['user']);
    const { selectedCompany } = useSelector(state => state['company']);

    // Listen for sidebar button click
    useEffect(() => {
        const handleOpenClarence = () => setIsOpen(true);
        window.addEventListener('openClarence', handleOpenClarence);
        return () => window.removeEventListener('openClarence', handleOpenClarence);
    }, []);

    // Don't show for guests, if no company selected, or if AI features are disabled
    if (!SHOW_AI_FEATURES || !user || user['role'] === 'Guest' || !selectedCompany?.['_id']) return null;

    const toggleChat = () => {
        setIsOpen(!isOpen);
        if (isOpen) setIsExpanded(false); // Reset expanded state when closing
    };

    const toggleExpand = () => setIsExpanded(!isExpanded);

    return (
        <div className={`clarence-widget ${isExpanded ? 'expanded' : ''}`}>
            {isOpen &&
                <div className={`clarence-widget-chat ${isExpanded ? 'expanded' : ''}`}>
                    <ClarenceChat companyId={selectedCompany['_id']} onClose={toggleChat} onExpand={toggleExpand} isExpanded={isExpanded} />
                </div>
            }
            <button className={`clarence-widget-button ${isOpen ? 'active' : ''}`} onClick={toggleChat} title={isOpen ? "Close" : "Chat with Clarence AI"}>
                {isOpen ?
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                :
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" fill="currentColor" opacity="0.2"/>
                        <path d="M12 6v6l4 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2"/>
                    </svg>
                }
                {!isOpen && <span className="widget-label">Ask Clarence</span>}
            </button>
        </div>
    );
};

export default ClarenceWidget;
